<div class="document-tracing-modal">
  <div class="modal-header">
    <div class="header-content">
      <h2 mat-dialog-title>
        <mat-icon class="header-icon">account_tree</mat-icon>
        {{ getDocumentTypeDisplay() }} Tracing
      </h2>
      <div class="current-document-info" *ngIf="tracingData?.current_document">
        <span class="document-id">Current: {{ tracingData.current_document }}</span>
      </div>
    </div>
    <button mat-icon-button (click)="closeDialog()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="modal-content">
    <!-- Loading State -->
    <div class="loading-state" *ngIf="loading">
      <mat-icon class="loading-icon">hourglass_empty</mat-icon>
      <p>Fetching related documents...</p>
      <div class="loading-spinner"></div>
    </div>

    <!-- Content when loaded -->
    <div class="timeline-container" *ngIf="!loading">
      <!-- Timeline Line -->
      <div class="timeline-line"></div>
      
      <!-- Dynamic Document Timeline -->
      <div class="timeline-item" *ngFor="let docType of getAvailableDocumentTypes(); let i = index">
        <div class="timeline-icon" [ngClass]="docType + '-icon'">
          <mat-icon>{{ getDocumentIcon(docType) }}</mat-icon>
        </div>
        <div class="timeline-content">
          <div class="document-card" [ngClass]="docType + '-card'">
            <div class="card-header">
              <h3>{{ getDocumentTypeTitle(docType) }} ({{ getDocumentCount(docType) }})</h3>
              <span class="status-badge" [ngClass]="getDocumentStatusBadge(docType).class">
                {{ getDocumentStatusBadge(docType).text }}
              </span>
            </div>
            <div class="card-body">
              <div class="document-list">
                <div class="document-item" *ngFor="let doc of getDocuments(docType)">
                  <div class="doc-header">
                    <span class="doc-id">{{ doc.key }}</span>
                    <div class="doc-right">
                      <span class="doc-number" *ngIf="doc.value">#{{ doc.value }}</span>
                      <button mat-button 
                              class="view-btn" 
                              (click)="viewDocument(docType, doc.key, doc.value)"
                              title="View {{ getDocumentTypeTitle(docType) }}">
                        <mat-icon>visibility</mat-icon>
                        View
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="document-info">
                <span class="label">Total {{ getDocumentTypeTitle(docType) }}:</span>
                <span class="value">{{ getDocumentCount(docType) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No Documents Message -->
      <div class="no-documents-message" *ngIf="!hasAnyDocuments()">
        <mat-icon>info</mat-icon>
        <p>No related documents found for this {{ getDocumentTypeDisplay().toLowerCase() }}.</p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()" class="close-btn">Close</button>
  </mat-dialog-actions>
</div> 